document.addEventListener('DOMContentLoaded', () => {
    const FREE_SHIPPING_THRESHOLD = 50; // dollars

    const drawers = [
        {
            name        : 'cart',
            element     : document.getElementById('shopify-section-cart-drawer'),
            openButtons : [document.querySelector('.open-cart')],
            closeButtons: [document.querySelector('.close-cart')],
        }, {
            name        : 'mobileMenu',
            element     : document.querySelector('.menu-drawer'),
            openButtons : [document.querySelector('.header-hamburger')],
            closeButtons: [document.getElementById('close-menu-drawer')],
        },
    ];

    const overlay = document.querySelector('.drawer-overlay');

    // Wire open/close buttons
    drawers.forEach(({ element, openButtons = [], closeButtons = [] }) => {
        openButtons.filter(Boolean).forEach(btn => btn.addEventListener('click', () => openDrawer(element)));
        closeButtons.filter(Boolean).forEach(btn => btn.addEventListener('click', () => closeDrawer(element)));
    });

    // Core drawer controls
    function openDrawer(drawer) {
        if (!drawer) return;
        closeAllDrawers(); // only one open at a time
        drawer.classList.add('active');
        drawer.setAttribute('aria-hidden', 'false');
        overlay?.classList.add('active');
        document.body.classList.add('menu-open');
    }

    function closeDrawer(drawer) {
        if (!drawer) return;
        drawer.classList.remove('active');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('menu-open');
        overlay?.classList.remove('active');
    }

    function closeAllDrawers() {
        drawers.forEach(({ element }) => closeDrawer(element));
        overlay?.classList.remove('active');
    }

    function openCartDrawer() {
        const cartDrawer = drawers.find(d => d.name === 'cart')?.element;
        if (cartDrawer) openDrawer(cartDrawer);
    }

    document.addEventListener('click', (event) => {
        const closeBtn = event.target.closest('.close-cart');
        if (!closeBtn) return;
        event.preventDefault();
        const cartDrawer = drawers.find(d => d.name === 'cart')?.element;
        if (cartDrawer) {
            closeDrawer(cartDrawer);
        }
    });

    // Overlay + ESC
    overlay?.addEventListener('click', closeAllDrawers);
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeAllDrawers();
    });

    // ===== FREE SHIPPING HELPERS =====
    function updateFreeShippingBar(cart) {
        const textEl  = document.querySelector('.free-shipping-text');
        const barFill = document.querySelector('.free-shipping-progress-fill');
        if (!textEl || !barFill || !cart) return;

        const subtotalCents = cart.items_subtotal_price ?? cart.total_price ?? 0;
        const subtotal = subtotalCents / 100;
        const remaining = FREE_SHIPPING_THRESHOLD - subtotal;

        if (remaining > 0) {
            textEl.textContent = `Add $${remaining.toFixed(2)} more to get Free Shipping`;
            const percent = Math.min((subtotal / FREE_SHIPPING_THRESHOLD) * 100, 100);
            barFill.style.width = `${percent}%`;
        } else {
            textEl.textContent = `You've got Free Shipping! 🎉`;
            barFill.style.width = `100%`;
        }
    }

    // ===== LIQUID AJAX CART INIT =====
    function onAjaxCartInit() {
        updateFreeShippingBar(window.liquidAjaxCart?.cart);
    }
    if (window.liquidAjaxCart?.init) {
        onAjaxCartInit();
    } else {
        document.addEventListener('liquid-ajax-cart:init', onAjaxCartInit);
    }

    // ===== LISTEN FOR CART REQUESTS (Optimistic open) =====
    document.addEventListener('liquid-ajax-cart:request-start', (event) => {
        const { requestState } = event.detail || {};
        // Open ASAP when adding to cart (no network wait)
        if (requestState?.requestType === 'add') {
            openCartDrawer();
        }
    });

    // ===== LISTEN FOR CART UPDATES (progress + errors) =====
    document.addEventListener('liquid-ajax-cart:request-end', (event) => {
        const { requestState, cart } = event.detail || {};

        if (requestState?.responseData?.ok && cart) {
            updateFreeShippingBar(cart);
        } else if (requestState?.requestType === 'add' && !requestState?.responseData?.ok) {
            // Optional: handle add-to-cart failure (drawer is already open optimistically)
            // e.g., show a toast message inside the drawer
            const errTarget = document.querySelector('.cart-drawer-error');
            if (errTarget) {
                errTarget.textContent = requestState?.responseData?.message || 'Could not add to cart.';
            }
        }
    });
});